import { $api } from '../y/api';
import { YId, YTimeString } from '../y/types';
import { CEventId } from './c-event';

export interface CHReview {
    id: YId;
    text: string;
    rating?: 'up' | 'down';
    user_name: string;
    created_at: YTimeString;
}

export function chReviewsByEvent(id: CEventId) {
    return $api.cachedGET<CHReview[]>(`event/${id}/reviews`);
}
